import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  container: ({ isLast }: { isLast: boolean }) => ({
    boxShadow: isLast ? "none" : "0 1px 1px rgba(0, 0, 0, 0.05)",
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
    },
  }),
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flex: 1,
  },
  segmentDetailsLeft: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  segmentHeader: {
    cursor: "pointer",
  },
  activeChip: {
    backgroundColor: theme.palette.primary.main,
  },
  audienceCustomers: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
}));
